import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';

import BusinessList from 'components/businesses/BusinessList';
import BusinessApi from 'apis/Business';
import BusinessModal from 'components/businesses/BusinessModal';
import { ROUTES } from 'constants/Routes.js';
import Loading from 'utils/Loading';
import 'assets/scss/business.css';
import CategoryApi from '../apis/Category';

class Business extends Component {
  constructor() {
    super();
    this.state = {
      businesses: [],
      modalToggle: false,
      deleteId: '',
      response: false,
      category: {},
      deleteBusinessName: '',
      searchText: '',
    };
  }

  componentWillMount() {
    this.fetchBusinesses();
    this.fetchCategoryDetail();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.categoryId != this.props.match.params.categoryId
    ) {
      this.fetchCategoryDetail();
    }
  }

  handleFilterInput = e => {
    const { value } = e.target;

    this.setState({ searchText: value });
  };

  fetchCategoryDetail = () => {
    const { categoryId } = this.props.match.params;
    if (categoryId) {
      CategoryApi.getDetails(categoryId).then(({ data }) => {
        this.setState({ category: data });
      });
    }
  };

  fetchBusinesses = () => {
    BusinessApi.getAll()
      .then(({ data }) => {
        this.setState({ businesses: data, response: true });
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Connection Error
            </div>
          )),
          console.log(e)
        )
      );
  };

  deleteBusiness = (id, name) => {
    this.setState({
      modalToggle: true,
      deleteId: id,
      deleteBusinessName: name,
    });
  };

  confirmDeleteBusiness = () => {
    const { deleteId, deleteBusinessName } = this.state;
    BusinessApi.delete(deleteId)
      .then(({ data }) => {
        this.fetchBusinesses();
        this.cancelDelete();
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Deleted business {deleteBusinessName}{' '}
          </div>
        ));
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Connection Error{' '}
            </div>
          )),
          console.log(e)
        )
      );
  };

  cancelDelete = () => {
    this.setState({
      modalToggle: false,
    });
  };

  render() {
    const { id: surveyTemplateId, categoryId } = this.props.match.params;
    const {
      deleteBusinessName,
      response,
      modalToggle,
      businesses,
      searchText,
      category,
    } = this.state;

    if (!response) {
      return <Loading />;
    }

    return (
      <div className="container">
        <BusinessModal
          modalToggle={modalToggle}
          cancelDelete={this.cancelDelete}
          deleteBusinessName={deleteBusinessName}
          confirmDeleteBusiness={this.confirmDeleteBusiness}
        />

        <div className="row mb-4 justify-content-between">
          {categoryId ? (
            <div className="col-lg-3 col-md-12 business-category-title">
              <span className="category-container">
                {category.name}
                <NavLink to={ROUTES.BUSINESS_INDEX} className="ml-2">
                  <FontAwesomeIcon icon="times" />
                </NavLink>
              </span>
            </div>
          ) : (
            <div className="col-lg-3 col-md-12 business-count">
              <span className="count-container">
                {parseFloat(businesses.length).toLocaleString()}
              </span>
            </div>
          )}
          <div className="pl-lg-5 col-lg-9 col-md-12 input-group justify-content-end">
            <input
              className="col-lg-9 col-md-12 form-control search-text-box"
              placeholder="Enter search keyword"
              value={searchText}
              onChange={this.handleFilterInput}
            />
            <div className="input-group-append">
              <button className="btn btn-add-new d-flex align-items-center justify-content-center">
                <FontAwesomeIcon icon="search" className="d-none d-md-block" />
                Search
              </button>
            </div>
            <NavLink
              to={ROUTES.ADD_NEW_BUSINESS}
              className="ml-1 col-lg-3 col-md-12 btn btn-light btn-add-new d-flex justify-content-center align-items-center mt-3 mt-lg-0"
            >
              <FontAwesomeIcon icon="plus" />
              Add Business
            </NavLink>
          </div>
        </div>
        <BusinessList
          searchText={searchText}
          businesses={businesses}
          deleteBusiness={this.deleteBusiness}
          editBusiness={this.editBusiness}
          surveyTemplateId={surveyTemplateId}
          categoryId={categoryId}
        />
      </div>
    );
  }
}

Business.propTypes = {
  match: PropTypes.object,
};

export default Business;



// WEBPACK FOOTER //
// ./src/containers/Business.js